import React from 'react'
import DashboardPanel from "./DashboardPanel";
import {Link} from "react-router-dom";
import ScrollArea from "react-scrollbar";
import EmptyBanner from "../../../components/EmptyBanner";
import LoadingSpinner from "../../../components/LoadingSpinner";
import TalentPortal from "../../talent-portal/TalentPortal";


export default class ContractsPanel extends DashboardPanel {

    static header ='talent.dashboard.contracting_title';

    static is_active = true;
    static inactiveMessage = 'View a sample project contract and manage your contracts all in one place. Access our online payment and 1099 system.';

    static columns = 'auto'
    static colClass= 'max-w-[calc(100vw_-_1.5rem)] order-6 mb-6 w-full sm:px-3 md:w-6/12 xl:w4/12';

    static columnProps = {
        xl: 4,
        lg: 6,
        md: 6,
        sm: 12,
        xs: 12
    }
    static columnOrdering = {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6
    }

    isDisabled() {
        return !this.context?.auth?.isProfileApproved()
    }
    disabledReason() {
        return 'Your profile must be complete and your submission accepted in order to view contracts.';
    }
    // Uncomment this out to show days since last viewed contracts

    // daysSinceUpdated()
    // {
    //     let {lastViewed} = this.props;
    //     if (!lastViewed) {
    //         return;
    //     }

    //     let days = TB.moment().diff(lastViewed, 'days');
    //     if (days < 0) days = 0;

    //     return days;
    // }

    renderPanelContent()
    {
        let {contracts} = this.props;
        if (!contracts) {
            return (
                <div className="flex flex-col items-center justify-center flex-grow">
                    <LoadingSpinner size={'lg'}/>
                </div>
            )
        }

        return (
            <div className="talent-panel-content-container">

                {/*<button disabled className="btn btn-link dashboard-panel-link">*/}
                {/*    View and Manage Payments*/}
                {/*</button>*/}

                <div className="opportunity-list">
                    <div className="opportunity-list-section">
                        <div className="opportunity-status-row">
                            <p className="dashboard-panel-label">
                                Recent Contracts
                            </p>
                        </div>
                        <div className="opportunity-list-items">
                            <ScrollArea
                                speed={0.8}
                                className="area"
                                smoothScrolling={false}
                                contentClassName="scroll-area"
                                stopScrollPropagation={true}
                                horizontal={false}>
                                {contracts.length > 0 ? contracts.map((contract, index) => (
                                    <a target="_blank" href={contract.path} key={`contract-${index}`}
                                          className="opportunity-list-item px-2">
                                        <p className="mb-0">
                                            {contract.name}
                                        </p>
                                    </a>
                                )) : (
                                    <EmptyBanner message={`No Recent Contracts Available`}/>
                                )}
                            </ScrollArea>
                        </div>
                    </div>
                </div>

                <div className="flex mt-2 justify-end">
                    <Link to={TalentPortal.contractsPath()} className="btn btn-primary">
                        View All Contracts
                    </Link>
                </div>
            </div>
        )
    }
}